import { PACKAGE_NAMESPACE } from 'src/constants';
import { backendHost } from 'src/global';
import {
  RestClientBuilder,
  RestClientBuilderConfig,
} from 'src/utils/fetchRestClient';

export const DEFAULT_REST_CLIENT_BUILDER_CONFIG: RestClientBuilderConfig = {
  headers: {
    ...(process.env.NEXT_PUBLIC_LOCAL === 'false'
      ? {
          'Front-Initiator-Namespace': PACKAGE_NAMESPACE,
        }
      : {}),
  },
  onError: (error) => {
    console.error(`Failed to fetch: ${error.message}`);
  },
};

const builder = new RestClientBuilder(DEFAULT_REST_CLIENT_BUILDER_CONFIG);

export const contentV1 = builder.createInstance({
  baseURL: `${backendHost}/content/v1/`,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
});

export const contentV2 = builder.createInstance({
  baseURL: `${backendHost}/content/v2/`,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
});

export const naumengatewayV1 = builder.createInstance({
  baseURL: `${backendHost + `/naumengateway/v1/`}`,
  responseType: 'json',
});

export const facadeV4 = builder.createInstance({
  baseURL: `${backendHost}/facade/v4/`,
  headers: {
    'Content-type': 'application/json;charset=utf-8',
  },
});

export const mindboxgatewayV1 = builder.createInstance({
  baseURL: `${backendHost}/mindboxgateway/v1/`,
});

export const calculatorV2 = builder.createInstance({
  baseURL: `${backendHost}/calculator/v2/`,
});

export const backendHostInstance = builder.createInstance({
  baseURL: backendHost,
});
